import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  ElementRef,
  inject,
  OnInit,
  signal,
  viewChild,
  WritableSignal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ShadowLayerService } from '@shared/services/shadow-layer.service';
import { UtilityService } from '@shared/services/utility.service';
import { fromEvent, Observable } from 'rxjs';
import { FooterComponent } from '../footer/footer.component';

@Component({
  standalone: false,
  selector: 'gstar-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent implements OnInit, AfterViewInit {
  private readonly shadowLayerService = inject(ShadowLayerService);
  private readonly utilitiesService = inject(UtilityService);
  private readonly destroyRef = inject(DestroyRef);

  showShadowLayer: Observable<boolean>;
  isLoaded: WritableSignal<boolean> = signal(false);
  footer = viewChild<FooterComponent>('footer');
  mainContainer = viewChild<ElementRef<HTMLDivElement>>('mainContainer');

  constructor() {
    this.showShadowLayer = this.shadowLayerService.showShadowLayer;
  }

  ngOnInit(): void {
    this.isLoaded.set(true);
  }

  ngAfterViewInit(): void {
    fromEvent(this.mainContainer()!.nativeElement, 'scroll')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((event: Event) => {
        this.utilitiesService.mainContentScroll(event);
      });
  }
}
